import { render, staticRenderFns } from "./CouponOrders.vue?vue&type=template&id=b3dc7bac&scoped=true&"
import script from "./CouponOrders.vue?vue&type=script&lang=js&"
export * from "./CouponOrders.vue?vue&type=script&lang=js&"
import style0 from "./CouponOrders.vue?vue&type=style&index=0&id=b3dc7bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dc7bac",
  null
  
)

export default component.exports